// Mutation hook - usuniecie aktywnosci transakcji
// DELETE /api/ui/sales-crm/deals/{id}/activities/{activityId}

import { axios } from 'api';
import { useMutation, UseMutationOptions, useQueryClient } from 'react-query';
import { ICommandResponseError as IError } from 'api/types';

interface IDeleteDealActivityResponse {
  data?: { id?: number };
  message?: string;
  status?: string;
}

interface IDeleteDealActivityVariables {
  dealId: number;
  activityId: number;
}

const deleteDealActivity = ({ dealId, activityId }: IDeleteDealActivityVariables): Promise<IDeleteDealActivityResponse> =>
  axios.delete(`/sales-crm/deals/${dealId}/activities/${activityId}`);

export const useDeleteDealActivity = (
  options?: UseMutationOptions<IDeleteDealActivityResponse, IError, IDeleteDealActivityVariables>,
) => {
  const queryClient = useQueryClient();
  return useMutation<IDeleteDealActivityResponse, IError, IDeleteDealActivityVariables>(deleteDealActivity, {
    ...options,
    onSuccess: async (data, variables, context) => {
      await queryClient.invalidateQueries(['sales-crm-deal-activities', variables.dealId]);
      await queryClient.refetchQueries(['sales-crm-deal-activities', variables.dealId]);
      options?.onSuccess?.(data, variables, context);
    },
  });
};
